import React, { useContext } from 'react'
import { useGetResultsGroupedByYear } from '@BUP/hooks/Sociogram/useGetResultsGroupedByYear'
import { useGetCurrentTerm } from '@BUP/hooks/Terms/useGetCurrentTerm'
import { useGetEventsByTermId } from '@BUP/hooks/Events/useGetEventsByTermId'
import CollapsePanel from '@BUP/components/Generics/CollapsePanel'
import AlertComponent from '@BUP/components/Generics/Alert'
import BupSpinner from '@BUP/components/Loading/Spinner'
import PageLayout from '@BUP/components/Layout/Page'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { useTranslation } from 'react-i18next'
import styles from './historic-sociogram.module.scss'
import SurveyElement from './survey-element'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'

const HistoricSociogramPage = () => {
  const i18n = useTranslation()
  const organization = useContext(OrganizationContext)
  const organizationId = organization.id
  const { isLoadingResults, results } = useGetResultsGroupedByYear(organizationId)
  const { loading: isLoadingResultsRecommendations, data: resultsRecommendations, error: errorResultRecommendations } = useGetOrganizationRecommendations()
  const { loadingTerm, term } = useGetCurrentTerm()
  const termId = term && term.id
  const { isLoadingEvents, dataEvents } = useGetEventsByTermId(termId)
  const arrayCurrentSociograms =
    dataEvents && dataEvents.map(elem => elem?.activityId)

  if (isLoadingResults || loadingTerm || isLoadingEvents || isLoadingResultsRecommendations) {
    return (
      <PageLayout>
        <BupSpinner
          size='large'
          tip={i18n.t('common.resources.generic.actions.any.loading')}
        />
      </PageLayout>
    )
  }

  if (!results || Object.keys(results).length === 0) {
    return (
      <PageLayout pageName={i18n.t('pages.data.historicalSociogram.title')}>
        <div className={styles.alert_wrapper}>
          <AlertComponent
            message={i18n.t('pages.data.historicalSociogram.results.empty')}
            type='warning'
          />
        </div>
      </PageLayout>
    )
  }

  return (
    <PageLayout pageName={i18n.t('pages.data.historicalSociogram.title')}>
      <div className={styles.collapse_wrapper}>
        {Object.keys(results).map(year => {
          const sortedYearResults = results[year].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

          return (
            <CollapsePanel
              label={<h4 className={styles.collapse_title}>{`Año ${year}`}</h4>}
              arrowColor='#FFFFFF'
              buttonColor='#A78CD9'
              borderRadius='0.25rem'
              id={year}
              shadow
              key={year}
              borderRadiusBottom
            >
              <div className={styles.list_wrapper}>
                {sortedYearResults.map(result => {
                  const resource = resultsRecommendations.find(elem => elem.resultId === result.id)
                  if (
                    arrayCurrentSociograms?.includes(result.survey.sociogram_id)
                  ) { return null }
                  return (
                    <SurveyElement key={result.id} courseId={parseInt(result.courseId, 10)} result={result} resource={resource} errorResource={errorResultRecommendations} />
                  )
                })}
              </div>
            </CollapsePanel>
          )
        })}
      </div>
    </PageLayout>
  )
}

export default HistoricSociogramPage
